export const STORAGE = {
  USER: "user",
  USERNAME: "support@fxsmartbull.com",
  PASSWORD: "123456",
};
